import { Component, Input, ViewChild, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-directory-search',
  templateUrl: './directory-search.component.html',
  styleUrls: ['./directory-search.component.scss']
})
export class DirectorySearchComponent
{
  @ViewChild('directorySearchSource') public directorySearchSource: DirectorySearchComponent;

  @Input() public allowSelection = false;
  @Input() public singleSelectionOnly = false;
  @Input() public disableEscape = false;
  @Input() public showOrganizationsTab = false;
  @Input() public doNotResetScrollOnClose = false;
  @Input() public allowFacilitySearch = true;
  @Input() public memberId: number;

  @Output() public selectProvider = new EventEmitter();

  public kno2DirectoryDialogOpened = false;
  public channelsDirectoryDialogOpened = false;

  public execute(): void
  {
    this.directorySearchSource.execute();
  }

  public onOpenDirectorySearch(directorySource: string): void
  {
    switch (directorySource)
    {
      case 'CHANNELS':
        this.channelsDirectoryDialogOpened = true;
        break;
      case 'KNO2':
        this.kno2DirectoryDialogOpened = true;
        break;
    }
  }

  public onSelectProviders(providers: any): void
  {
    this.resetDialogOpened();
    this.selectProvider.emit(providers);
  }

  private resetDialogOpened(): void
  {
    this.kno2DirectoryDialogOpened = false;
    this.channelsDirectoryDialogOpened = false;
  }
}
